const tokens = {
  logOutButtonVariant: 'secondaryInverse',
  contactIconColor: 'brandTwo100',
  enableCallToActionButton: false,
  enableSearch: false,
};

export default tokens;
